import React from 'react';
import EditorContext, { useEditorContext } from './EditorContext';

export const EditorContextProvider = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  console.assert(id, 'Editor context needs an ID');
  const value = useEditorContext(id);

  return <EditorContext.Provider value={value}>{children}</EditorContext.Provider>;
};
